import React from "react";

function PastMedicalHistory() {
  return (
    <div>
      <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
        <div className="header h-[13%] bg-[#FFD5B8] flex items-center justify-center rounded p-2">
          <h1 className="font-bold text-normal text-[#341f0b] mt-3">
            Past Medical History
          </h1>
        </div>
        <div className="body h-[75%] overflow-y-auto bg-white scrollwidth border-t-2 border-t-[#FB7800]">
          <div className="flex justify-between items-center p-2 m-3 border rounded-md">
            <h5 className="font-semibold text-sm">Thyroid</h5>
            <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
          </div>
          <div className="flex justify-between items-center p-2 m-3 border rounded-md">
            <h5 className="font-semibold text-sm">Hypertension</h5>
            <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
          </div>
          <div className="flex justify-between items-center p-2 m-3 border rounded-md">
            <h5 className="font-semibold text-sm">Tuberculosis</h5>
            <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
          </div>
          <div className="flex justify-between items-center p-2 m-3 border rounded-md">
            <h5 className="font-semibold text-sm">Cholesterol high</h5>
            <h5 className="text-gray-500 font-semibold text-sm">Onset date: <span>2024-12-21</span></h5>
          </div>
        </div>
        <div className="footer h-[44px] bg-[#FFD5B8] rounded"></div>
      </div>
    </div>
  );
}

export default PastMedicalHistory;
